import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/seo/SEOHead';

export default function PrivacyPolicyPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://neurasites.ai';

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors">
      <SEOHead
        title="Privacy Policy | NeuraSites AI"
        description="Privacy Policy for NeuraSites AI website visitors and clients."
        canonicalUrl={`${siteUrl}/privacy-policy`}
      />
      <Header />
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-6">Privacy Policy</h1>
          <p className="text-gray-600 dark:text-gray-300 mb-6">Last updated: February 2026</p>

          <div className="space-y-6 text-gray-700 dark:text-gray-300 leading-relaxed">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">Information We Collect</h2>
              <p>We collect information you submit through forms (name, email, phone, project details), plus basic analytics data used to improve site performance and user experience.</p>
            </section>
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">How We Use Your Information</h2>
              <p>We use your information to respond to inquiries, provide services, send project updates, and improve our offerings. We do not sell your personal information.</p>
            </section>
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">Data Sharing</h2>
              <p>We may share limited information with trusted service providers (hosting, analytics, communication tools) only as needed to operate our business.</p>
            </section>
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">Data Security</h2>
              <p>We use reasonable safeguards to protect your information, including secure infrastructure and access controls.</p>
            </section>
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-2">Your Rights</h2>
              <p>You may request access, correction, or deletion of your information by contacting us at hello@neurasites.ai.</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
